module.exports = __webpack_public_path__ + "img/6.0e97097d.webp";